export default {
    resources (state) {
      return state.resources
    },

    selectedResource (state) {
        return state.selectedResource
    },

    getResource: state => (resourceId) => {
      return state.resources.find(resource => resource.newsResourcesId === resourceId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/resources/getters.js